import { render, staticRenderFns } from "./SortingIndicator.vue?vue&type=template&id=14546ba2&"
import script from "./SortingIndicator.vue?vue&type=script&lang=js&"
export * from "./SortingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports